


















	// @ts-ignore
    import _ from './MSelectColorSidecover.ts'; export default _;
